// SPDX-License-Identifier: AGPL-3.0-or-later

const LIBRARY_MARKER = '/* fluxer:synced-library */';
const OVERRIDES_MARKER = '/* fluxer:synced-overrides */';

function trimCss(value: string | null | undefined): string | null {
	if (typeof value !== 'string') {
		return null;
	}
	const trimmed = value.trim();
	return trimmed.length > 0 ? trimmed : null;
}

export function encodeSyncedThemeCss(
	libraryCss: string | null | undefined,
	overrideCss: string | null | undefined,
): string | undefined {
	const library = trimCss(libraryCss);
	const overrides = trimCss(overrideCss);
	if (library == null) {
		return overrides ?? undefined;
	}
	if (overrides == null) {
		return `${LIBRARY_MARKER}\n${library}`;
	}
	return `${LIBRARY_MARKER}\n${library}\n${OVERRIDES_MARKER}\n${overrides}`;
}

export function decodeSyncedThemeCss(css: string | null | undefined): {
	libraryCss: string | null;
	overrideCss: string | null;
} {
	const raw = trimCss(css);
	if (raw == null) {
		return {libraryCss: null, overrideCss: null};
	}
	const libraryIndex = raw.indexOf(LIBRARY_MARKER);
	if (libraryIndex < 0) {
		return {libraryCss: null, overrideCss: raw};
	}
	const afterLibrary = raw.slice(libraryIndex + LIBRARY_MARKER.length);
	const overridesIndex = afterLibrary.indexOf(OVERRIDES_MARKER);
	if (overridesIndex < 0) {
		return {libraryCss: trimCss(afterLibrary), overrideCss: null};
	}
	return {
		libraryCss: trimCss(afterLibrary.slice(0, overridesIndex)),
		overrideCss: trimCss(afterLibrary.slice(overridesIndex + OVERRIDES_MARKER.length)),
	};
}
